module.exports = __webpack_public_path__ + "bg.b799ad789dc0f71515c2.png";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/images/login/bg.png
// module id = ../../../../../src/assets/images/login/bg.png
// module chunks = main